export default "__VITE_ASSET__W_ZFRiH4__"